import { render } from "./UserInfoComponent.vue?vue&type=template&id=553c52d2&scoped=true"
import script from "./UserInfoComponent.vue?vue&type=script&lang=js"
export * from "./UserInfoComponent.vue?vue&type=script&lang=js"

import "./UserInfoComponent.vue?vue&type=style&index=0&id=553c52d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553c52d2"]])

export default __exports__